import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { useCallback, useContext } from 'react';

import type { SmartCardAppearance } from '@trello/smart-card';
import { SmartLink, SmartLinkAnalyticsContext } from '@trello/smart-card';

import { trelloLinkHandler } from 'app/src/trelloLinkHandler';

export interface FriendlyLinkProps {
  hrefProps: AnchorHTMLAttributes<HTMLAnchorElement>;
  appearance?: string | null;
  children?: ReactNode;
}

export const FriendlyLink = ({
  hrefProps,
  appearance = 'inline',
  children,
}: FriendlyLinkProps) => {
  const context = useContext(SmartLinkAnalyticsContext);

  const { href } = hrefProps;

  const plainLink = useCallback(
    () => <a {...hrefProps}>{children}</a>,
    [children, hrefProps],
  );

  // if href !== children then we want to show the link name that the user set
  if (!href || href !== children || !appearance) {
    return plainLink();
  }

  return (
    <SmartLink
      url={href}
      appearance={appearance as SmartCardAppearance}
      plainLink={plainLink}
      analyticsContext={context}
      handleTrelloLinkClick={trelloLinkHandler}
    />
  );
};
